<div class="form-container">
  <form [formGroup]="form" (ngSubmit)="submitForm()">
    <input formControlName="password" type="password" required placeholder="Passwort" />
    <input formControlName="confirmPassword" type="password" required placeholder="Bestätigen Sie Ihr Passwort" />
    @if (form.get('password')?.touched && form.get('password')?.errors?.minlength) {
      <div class="form-error">
        Passwort muss mindestens {{passwordMinLength}} Zeichen lang sein
      </div>
    }
    @if (form.errors?.passwordsMismatch && form.touched) {
      <div class="form-error">
        Passwörter stimmen nicht überein
      </div>
    }
    @if (form.valid) {
      <button class="button-password"  type="submit">
        Absenden
      </button>
    }
  </form>

</div>